<template lang="html">
  <div id="d-home-page">

    <section class="box-basic-info">
      <div class="col col-i col-profile">
        <div class="col placed-backg col-image" v-bind:style="{ backgroundImage: 'url('+ $root.user.imageUrl +')' }" style="background-size: contain;"></div>

        <div class="col col-info">
          <h5 class="name">{{ $root.user.name }}  {{ $root.user.lastname }}</h5>
          <h6 class="position">{{ $root.user.position }}</h6>
         
          <h6 class="position" v-if="$root.user.brigades_id">
            <hr>
             <img :src="$root.user.imageUrlBrigade" width="100px"><br>
              <b>{{$root.user.brigade_name  }}</b><br>
              {{$root.user.position_brigades  }}
            </h6>

        </div>
      </div>



      <div class="col col-i col-extra-info">
        <h4 class="mb-2">Inicio de colaboración:</h4>
        <h6 class="mb-2">{{ $root.user.start_workk }}</h6>
        <h6 class="position" style="font-weight: 400;" v-if="$root.user.departament"><span style="font-weight: 600;">Departamento: </span>{{ $root.user.departament }}</h6>
        <h6 class="position" style="font-weight: 400;" v-if="$root.user.immediate_boss"><span style="font-weight: 600;">Jefe inmediato: </span>{{ $root.user.immediate_boss }}</h6>
        <h6 class="position" style="font-weight: 400;" v-if="$root.user.area_manager"><span style="font-weight: 600;">Gerente de area: </span>{{ $root.user.area_manager }}</h6>
        <h6 class="position" style="font-weight: 400;" v-if="$root.user.agencies"><span style="font-weight: 600;">Agencia: </span>{{ $root.user.agencies }}</h6>
      </div>
    </section>

    <section class="box-st-1 box-announcement">
      <div class="box-title">Comunicados</div>

      <div class="box-content">
        <router-link
          class="post-template-s1"
          v-for="(c, cInx) in blogs"
          :key="'cInx-'+cInx"
          :to="{ name: 'accComuDetallePage', params: { id: c.id } }">
          <div class="placed-backg col box-image" v-bind:style="{ backgroundImage: 'url(' +c.imageUrl+ ')' }"></div>
          <div class="col box-text">
            <h5 class="title">{{c.title}}</h5>
            <!-- <h6 class="subtitle">Lorem ipsu</h6> -->

            <div class="descr">
              <p>{{c.description}}</p>
            </div>
          </div>
        </router-link>
      </div>
    </section>

    <section class="row mt-5">
      <div class="col-lg-6">
        <div class="box-st-1 box-announcement-s2">
          <div class="box-title">Hoy conoce a:</div>

          <div class="box-content">
            <div class="carousel-employees">
              <swiper class="swiper" :options="employeesOptions">
                <swiper-slide v-for="(co, bhInx) in collaborators" :key="'col-'+bhInx">
                  <div class="post-template-s2">
                    <div class="placed-backg col-12 box-image" v-bind:style="{ backgroundImage: 'url(' +co.imageUrl+ ')' }">
                      <img src="public/images/shared/empty-1.png">
                    </div>

                    <div class="col-12 box-text">
                      <h5 class="title">{{ co.name }} {{ co.lastname }}</h5>
                      <h6 class="subtitle">{{ co.position }}</h6>
                      <h6 class="subtitle">{{ co.departament }}</h6>
                      <h6 class="subtitle">{{ co.agency }}</h6>
                      <hr />

                      <div class="descr">
                        <p>{{ co.outstanding_comments }}</p>
                      </div>
                    </div>
                  </div>
                </swiper-slide>

                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
              </swiper>
            </div>
          </div>
        </div>

      </div>

      <div class="col-lg-6 mt-4 mt-lg-0">
        <div class="box-st-1 box-announcement-s2">
          <div class="box-title">
            <span>Beneficios del día</span>
            <router-link class="f-w-400 float-right" :to="{ name: 'accBeneficiosPage' }">Ver todos</router-link>
          </div>

          <div class="box-content">
            <router-link class="post-template-s2" :to="{ name: 'accBeneDetallePage', params: { id: benefit.id } }">
              <div class="placed-backg col-12 box-image" v-bind:style="{ backgroundImage: 'url(' +benefit.imageUrl+ ')' }" style="background-size: contain;">
                <img src="public/images/shared/empty-1.png">
              </div>

              <div class="col-12 box-text">
                <h5 class="title">{{benefit.name}}</h5>
                <!-- <h6 class="subtitle">x</h6> -->

                <div class="descr">
                  <p>{{benefit.description}}</p>
                </div>

                <hr />

                <p>
                  <span class="btn-more">Ver detalle</span>
                </p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      blogs: [],
      collaborators:[],

      benefit:{
        name:null,
        description:null,
        imageUrl:null,
        id:null,
      },

      // == Carousel options ==
      employeesOptions: {
        loop: true,
        speed: 600,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
      // == ==
    }
  },

  watch:{
  },

  methods: {
    home(){
      axios.get(tools.url("/api/home")).then((response)=>{
        this.blogs = response.data.blogs;
        this.collaborators = response.data.collaborators;
        this.benefit = response.data.benefit;
      }).catch(()=>{});
    }
  },

  mounted(){
    this.home();
  }
}
</script>
